module.exports = __webpack_public_path__ + "static/media/unep.720ddb1a.png";